import React from "react";
import '../Styles/footer.css';
import {Link} from "react-router-dom";

export default function Footer() {

    return (
        <div>
            <footer className="foot">
                <div className="overlay">
                    <h3>{`2024 Book'Info`}</h3>

                    <div className={"links"}>
                        <Link className={"link"} to={"/"}>Accueil</Link>
                        <Link  className={"link"} to={"/advanced-search"}>Recherche avancée</Link>
                    </div>
                </div>
            </footer>
        </div>
    );
}
